import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PagesService {

  constructor(
    private httpClient: HttpClient
  ) {}

  public getConfig<T>(parameters: any = null) : Observable<T> {
    parameters = {slug: "config"};
    return this.getData(parameters);
  //   return new Observable<T>((observer) => {
  //     this.httpClient.get(environment.apiUrl + '/pages', { params: parameters } )
  //       .subscribe(    
  //         (response) => {          
  //           observer.next(this._handleGetResponse(response[0]));
  //           observer.complete();        
  //         },
  //         (error) => {
  //           observer.error(this._handleGetResponse(error));
  //         }
  //       )
  //   });
  }

  public getData<T>(parameters: any = null) {
    return new Observable<T>((observer) => {
      this.httpClient.get(environment.apiUrl + '/pages', { params: parameters } )
        .subscribe(    
          (response) => {          
            observer.next(this._handleGetResponse(response[0]));
            observer.complete();        
          },
          (error) => {
            observer.error(this._handleGetResponse(error));
          }
        )
    });
  }

  public sendComments<T>(parameters: any = null) {
    return new Observable<T>((observer) => {
      this.httpClient.post(
        environment.apiUrlSlownik + '/comments',
        {},
        {
          'params': parameters
        }
      ).subscribe(    
        (response) => {          
          observer.next(this._handleGetResponse(response[0]));
          observer.complete();        
        },
        (error) => {
          observer.error(this._handleGetResponse(error));
        }
      )
    });
  }
  
  public get<T>(id: number,  parameters: any = null) {
    return new Observable<T>((observer) => {

      this.httpClient.get(environment.apiUrl + '/pages/' + id, { params: parameters } )
        .subscribe(    
          (response) => {          
            observer.next(this._handleGetResponse(response));
            observer.complete();        
          },
          (error) => {
            observer.error(this._handleGetResponse(error));
          }
        )
    });
  }
  
  private _handleGetResponse(response: any) {
    return this._handleResponse(response);
  }

  private _handleResponse(response: any) {
    if (response && response.status) {
      switch (response.status) {
        case 500:
          alert(500);
          break;
        case 401:
          alert('Błąd 401 - Brak dostępu.');
          break;
        case 404:
          alert('Błąd 404 - Strona nie istnieje.');
          break;  
      }
    }

    return response;
  }
}